export const environment = {
   URL: 'https://uat.repower-predictor.alpha.simadvisory.com/',
  KEYCLOAK_URL: 'https://auth.dev.simadvisory.com/auth',
  KEYCLOAK_REALM: 'D_SPRICED',
  KEYCLOAK_CLIENT_ID: 'D_SPRICED_Client',
  PROJECT_ID: 'oh',
  HELP_URL: "https://google.com",
  COMPANY_LOGO_SRC: "https://assets.alpha.simadvisory.com/logos/image.png",
  COMPANY_LOGO_TEXT: "REPOWERS PREDICTOR TOOL",
  SECONDARY_LOGO_SRC: "https://assets.alpha.simadvisory.com/Make-in-india.png",
  ICON_URL: "https://assets.alpha.simadvisory.com/logos/image.png",
  TAB_NAME: "REPOWERS PREDICTOR TOOL",
  HELP_ENABLED: "true",
  FEEDBACK_URL: "https://docs.google.com/forms/u/0/",
  FEEDBACK_ENABLED: "true",
  NOTIFICATION_ENABLED: "true",
  USER_ENABLED: "true",
  LOGOUT_ENABLED: "true",
  agentApiUrl: 'http://localhost:8081',
  USE_ALT_SIDENAV: true,
  ALT_COMPANY_LOGO_SRC: 'https://assets.alpha.simadvisory.com/cummins_white.png',
  ALT_SECONDARY_LOGO_SRC: 'https://assets.alpha.simadvisory.com/logos/sim-logo-white.png',
  SECONDARY_COLOR: '#DA291C',
  SECONDARY_COLOR_2: '#000000',
  TOOLBAR_TEXT_COLOR: '#ffffff',
  SIDEBAR_TEXT_COLOR: '#ffffff',
  THEME_OPTIONS_ENABLED: false,
  THEME_TOGGLE_ENABLED: false,
};
